import React from 'react';

/**
 * DEM surface on a filled section (docs/DEM_TERRAIN.md, section 4): the project DEM
 * profile along the model line in amber, labelled, drawn in the section's elevation
 * frame (FilledSection's overlay geometry: px, py, topo, surfaceMax). When the model has
 * its own topography the white model surface stays visible for comparison.
 */
export default function SectionTerrainOverlay({ demSurface, px, py, x0, x1, topo, surfaceMax, applied }) {
  if (!topo || !Array.isArray(demSurface) || demSurface.length < 2) return null;
  const pts = demSurface.filter(([x]) => x >= x0 && x <= x1).map(([x, z]) => [px(x), py(surfaceMax - z)]);
  if (pts.length < 2) return null;
  const last = pts[pts.length - 1];
  return (
    <g data-testid="section-dem-surface">
      <polyline points={pts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke="#111" strokeWidth={3} opacity={0.35} />
      <polyline points={pts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke="#fbbf24"
        strokeWidth={applied ? 1.6 : 1.2} strokeDasharray={applied ? undefined : '5 3'} opacity={0.95} />
      <text x={last[0] - 4} y={last[1] - 5} fill="#fbbf24" fontSize={9} textAnchor="end" stroke="#111" strokeWidth={2.5} paintOrder="stroke">
        {applied ? 'DEM surface' : 'DEM (model has own topography)'}
      </text>
    </g>
  );
}
